export default __webpack_public_path__ + "static/media/security.66919dd9.svg";